import { cva } from '@/styled-system/css';

export const pageContentRecipe = cva({
  base: {
    'boxSizing': 'content-box',
    'marginBlock': {
      base: 'Page.Content.margin.vert.mobile',
      md: 'Page.Content.margin.vert.tablet',
      xl: 'Page.Content.margin.vert.desktop',
    },
    '&:last-child': {
      marginBlockEnd: 0,
    },
    '[data-c11n-component="Page.Header"] + &': {
      marginBlockStart: '0',
    },
    'marginInline': 'auto',
    'paddingInline': {
      base: 'Page.padding.horz.mobile',
      md: 'Page.padding.horz.tablet',
      xl: 'Page.padding.horz.desktop',
    },
  },
  variants: {
    fluid: {
      true: {
        maxWidth: 'none',
      },
      false: {
        maxWidth: 'Page.width.max',
      },
    },
  },
});
